import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '../page/Home/Home.vue'
import QsArmourDoor from '../page/qsArmourDoor/qsArmourDoor.vue'
import LuxuryArmourDoor from '../page/luxuryArmourDoor/luxuryArmourDoor'
import CourtyardGloryDoor from "../page/courtyardGloryDoor/courtyardGloryDoor";
import FoisonDoor from "../page/foisonDoor/foisonDoor";
import Music from "../page/Music/Music";
import AirPodsDetails from "../page/Music/GoodsShow/AirPods Pro/AirPodsDetails";

const originalPush = VueRouter.prototype.push
    // 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

var router = new VueRouter({
    routes: [{
            path: '/',
            redirect: '/luxuryArmourDoor'
        },
        {
            path: '/home',
            component: Home,
        },
        {
            path: '/qsArmourDoor',
            component: QsArmourDoor,
        },
        {
            path: '/luxuryArmourDoor',
            component: LuxuryArmourDoor,
        },
        {
            path: '/courtyardGloryDoor',
            component: CourtyardGloryDoor,
        },
        {
            path: '/foisonDoor',
            component: FoisonDoor,
        },
        {
            path: '/music',
            component: Music,
        },
        {
            path: '/music/airpodspro',
            component: AirPodsDetails,
        }

    ],
    // mode: 'history'

})

// 经验证，这个路由守卫没什么用，因为vue-router在跳转的路径相同的时候，在执行这个路由守卫之前就拦截了
router.beforeEach((to, from, next) => {
    // console.log(to.path===from.path)
    if (to.path === from.path) {
        console.log('路由相等啦')
        return

    } else {
        next()
    }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js